export default theme => ({
  container: {
    width: props => props.width,
  },
});
